export const authRoles = {
  sa: ['SA'], // Only Super Admin has access
  admin: ['SA', 'ADMIN'], // Only SA & Admin has access
  user: ['SA', 'ADMIN', 'user'], // Only SA & Admin & Editor has access
  guest: ['SA', 'ADMIN', 'user', 'guest'] // Everyone has access
};
